import { useDocumentSnapshot } from '../../../../../firebase/firestore/hooks';
import { Collections } from '../../../../../firebase/firestore/collections';
import { Position } from '../../../../../firebase/firestore/documents/position';

export const usePositionBackgroundCheckSnapshot = (positionId?: string): Position | undefined => {
  return useDocumentSnapshot<Position>(Collections.POSITIONS, positionId);
};
